import VegaLite from "./VegaLite";
import _createClassFromLiteSpec from "./createClassFromLiteSpec";
export default VegaLite;
export var createClassFromLiteSpec = _createClassFromLiteSpec;